<template>
  <v-dialog v-model="dialog" max-width="400px">
    <v-card :loading="loading">
      <v-toolbar flat>
        <span class="title">Change password</span>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container v-if="changeOK">
          <v-row>
            <v-col cols="12">
              <span class="headline">Password changed!</span>
            </v-col>
          </v-row>
        </v-container>
        <v-form v-else>
          <v-text-field
            label="Email"
            name="email"
            v-model="credential.email"
            prepend-inner-icon="email"
            disabled
            outlined
          ></v-text-field>
          <v-text-field
            label="Old password"
            name="oldPassword"
            v-model="credential.oldPassword"
            :rules="[rules.required]"
            :error-messages="oldErrMsg"
            prepend-inner-icon="lock"
            type="password"
            outlined
          ></v-text-field>
          <v-text-field
            label="New password"
            name="newPassword"
            v-model="credential.newPassword"
            :rules="[rules.required]"
            :error-messages="newErrMsg"
            prepend-inner-icon="lock"
            :append-icon="showNew ? 'visibility' : 'visibility_off'"
            :type="showNew ? 'text': 'password'"
            @click:append="showNew = !showNew"
            outlined
          ></v-text-field>
          <v-container>
            <v-row>
              <v-col>
                <v-btn large block color="success lighten-1" @click="change">
                  <span>Change password</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import UserService from '@/services/UserService.js'

export default {
  name: 'PasswordChangeDialog',
  data: () => ({
    dialog: false,
    loading: false,
    changeOK: false,
    showNew: false,
    credential: { email: '', oldPassword: '', newPassword: '' },
    oldErrMsg: '',
    newErrMsg: '',
    rules: {
      required: v => !!v || 'Required.'
    }
  }),
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  methods: {
    open () {
      this.credential = Object.assign({}, {
        email: this.user.user.email,
        oldPassword: '',
        newPassword: ''
      })
      this.loading = false
      this.changeOK = false
      this.showNew = false
      this.oldErrMsg = ''
      this.newErrMsg = ''
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    change () {
      if (this.credential.oldPassword === this.credential.newPassword) {
        this.newErrMsg = 'The new password is the same as the old.'
        return
      } else {
        this.newErrMsg = ''
      }
      this.loading = true
      UserService.changePassword(this.credential)
        .then(resp => {
          this.changeOK = true
          this.loading = false
          this.oldErrMsg = ''
          this.newErrMsg = ''
          setTimeout(() => {
            this.close()
          }, 1000)
        })
        .catch(err => {
          if (err.response) {
            this.oldErrMsg = err.response.data.detail
          }
          this.loading = false
        })
    }
  }
}
</script>
